<template>
  <div :class="['row full-width justify-center', isMobile ? 'q-pt-md q-pb-lg' : 'q-py-lg']">
    <div :class="['row col-11 justify-between items-start', isMobile ? '' : 'q-pr-sm']">

      <!-- breadcrumbs-->
      <q-breadcrumbs class="row full-width q-pb-md q-pl-sm" active-color="grey-8" separator="/" separator-color="grey">
        <q-breadcrumbs-el class="text-primary-hover" label="صفحه اصلی" to="/"/>
        <q-breadcrumbs-el class="text-bold" :label="page.title"/>
      </q-breadcrumbs>

      <!-- post, comments -->
      <div :class="['row col-12 col-md-12', isMobile ? 'q-mb-md' : 'q-pr-md']">
        <div class="column full-width q-gutter-y-md">

          <!-- post -->
          <div class="column full-width border-radius border-solid bg-white text-grey-4">

            <!-- date, views -->
            <div class="row full-width q-pa-md justify-between items-center">

              <!-- date -->
              <div class="row items-center">
                <div :class="['row full-width', isMobile ? '' : 'q-mb-xs']">
                  <h1 :class="['text-weight-regular text-grey-8 q-ma-none', isMobile ? 'text-subtitle1 post-title-mobile' : 'text-h5']">
                    {{page.title}}
                  </h1>
                </div>
              </div>

            </div>

            <q-separator/>

            <!-- content -->
            <div :class="['column full-width', isMobile ? 'q-pa-md q-gutter-y-md' : 'q-pa-lg q-gutter-y-lg']">

<!--              &lt;!&ndash; title &ndash;&gt;-->
<!--              <div :class="['row full-width', isMobile ? '' : 'q-mb-xs']">-->
<!--                <h1 :class="['text-grey-9 q-ma-none', isMobile ? 'text-subtitle1 post-title-mobile' : 'text-h5']">-->
<!--                  مدیریت خیریه-->
<!--                </h1>-->
<!--              </div>-->

              <!-- image -->
              <!--<q-img class="border-radius full-width"
                     :src="post.image && `${baseUrl}/cdn/download/${post.image.fileName}`"
                     :height="isMobile ? '200px' : '400px'"/>-->

              <!-- body -->
              <div :class="['row full-width text-black', isMobile ? 'q-px-sm' : '']">
                  <div v-html="page.body" class="full-width ck-content"/>
<!--                <div>-->
<!--                  <p>-->
<!--                    لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ، و با استفاده از طراحان گرافیک است، چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است، و برای شرایط فعلی تکنولوژی مورد نیاز، و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد، کتابهای زیادی در شصت و سه درصد گذشته حال و آینده، شناخت فراوان جامعه و متخصصان را می طلبد، تا با نرم افزارها شناخت بیشتری را برای طراحان رایانه ای علی الخصوص طراحان خلاقی، و فرهنگ پیشرو در زبان فارسی ایجاد کرد، در این صورت می توان امید داشت که تمام و دشواری موجود در ارائه راهکارها، و شرایط سخت تایپ به پایان رسد و زمان مورد نیاز شامل حروفچینی دستاوردهای اصلی، و جوابگوی سوالات پیوسته اهل دنیای موجود طراحی اساسا مورد استفاده قرار گیرد.-->
<!--                  </p>-->
<!--                  <q-img src="data:image/jpeg;base64,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"-->
<!--                         class="full-width border-radius"></q-img>-->
<!--                </div>-->
              </div>
            </div>
            <q-separator/>
          </div>
        </div>
      </div>

      <!-- most-viewed posts, related posts -->
<!--      <div v-if="!isMobile" class="sticky-sidebar col-3 border-radius overflow-hidden">-->
<!--        <div class="column full-width q-gutter-y-md">-->
<!--          &lt;!&ndash; post &ndash;&gt;-->
<!--          <div class="column full-width border-radius border-solid bg-white text-grey-4">-->
<!--            &lt;!&ndash; date, views &ndash;&gt;-->
<!--            <div class="row full-width q-pa-md justify-between items-center">-->
<!--              &lt;!&ndash; date &ndash;&gt;-->
<!--              <div class="row items-center">-->
<!--                <p class="text-h6 text-grey-9 q-ma-none">نرم افزار آژانس مسافرتی</p>-->
<!--              </div>-->
<!--            </div>-->
<!--            <q-separator/>-->
<!--            &lt;!&ndash; content &ndash;&gt;-->
<!--            <div :class="['column full-width', isMobile ? 'q-pa-md q-gutter-y-sm' : 'q-pa-lg q-gutter-y-md']">-->
<!--              <div v-for="page in relatedPages" class="row full-width border-radius border-solid overflow-hidden text-grey-4">-->
<!--                <div class="col-12 col-md-5 border-right">-->
<!--                  <q-img class="border-radius full-width" style="height: 100px" :src="page.srcIMG"/>-->
<!--                </div>-->
<!--                <div class="col-7 bg-white">-->
<!--                  <div class="column full-width q-pa-md q-gutter-y-sm">-->
<!--                    <div class="row full-width items-center">-->
<!--                      <div class="line-clamp-2 text-grey-9 text-subtitle1 text-bold">{{page.title}}</div>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->

    </div>
  </div>
</template>

<script>
import {useMeta} from "quasar";
import CommentItem from "components/CommentItem.vue";
import BlogSidebar from "components/blog/BlogSidebar.vue";

export default {
  components: {BlogSidebar, CommentItem},
  async preFetch({store, currentRoute, previousRoute, redirect, ssrContext, urlPath, publicPath}) {
    if (ssrContext) {
      await store.dispatch('getMeta', {pageUrl: ssrContext.req.headers.host + currentRoute.path})
    } else {
      await store.dispatch('getMeta', {pageUrl: window.location.host + currentRoute.path})
    }
    if (store.state.preFetch.pageMeta == null) redirect('/404')

    let meta = {}
    meta.title = store.state.preFetch.pageMeta.metaTitle
    meta.description = store.state.preFetch.pageMeta.metaDescription
    meta.keywords = store.state.preFetch.pageMeta.metaKeywords
    return await store.dispatch('setMeta', meta)
  },
  name: "Page",
  data: () => ({
    baseUrl: process.env.API_URL,
    relatedPages: [
      {srcIMG: 'https://b2n.ir/imgRain', title: 'و نرم افزار مدد کاری و نیکو کاری استان خراسان رضوی واقع در ...'},
      {srcIMG: 'https://b2n.ir/imgRain', title: 'و نرم افزار مدد کاری و نیکو کاری استان خراسان رضوی واقع در ...'},
      {srcIMG: 'https://b2n.ir/imgRain', title: 'و نرم افزار مدد کاری و نیکو کاری استان خراسان رضوی واقع در ...'},
      {srcIMG: 'https://b2n.ir/imgRain', title: 'و نرم افزار مدد کاری و نیکو کاری استان خراسان رضوی واقع در ...'},
    ]
  }),
  computed: {
    isMobile() {
      return this.$q.screen.lt.md
    },
    page(){
      return this.$store?.state?.preFetch?.pageMeta
    }
  },
  methods: {

  },
  async mounted() {
    useMeta(this.$store.state.meta)

  }
}
</script>

<style lang="scss">
.sticky-sidebar {
  position: sticky;
  top: 60px;
}
.ck-content {
  img {
    display: flex;
    margin: auto;
    border-radius: 10px;
  }
}
.post-title-mobile{
  font-size: 1rem !important;
}
.line-before {
  position: relative;
  padding: 10px 0px;
  display: block;
}
.line-before::before {
  content: "";
  position: absolute;
  bottom: 0;
  background: #cccc;
  height: 1px;
  width: 100%;
  left: 0;
}
.line-before::after {
  content: "";
  position: absolute;
  bottom: 0;
  background: #f1185c;
  height: 3px;
  width: 50px;
  left: 50%;
  transform: translateX(-50%);
}
</style>
